import { useMemo } from 'react'

import { Flex } from 'antd'

import { getIsRichTextEmpty } from 'src/components/form/util'
import RenderedRichTextInput from 'src/components/RenderedRichTextInput/RenderedRichTextInput'

import HStack from '../Flex/HStack'
import QuickTip from '../QuickTip/QuickTip'
import { T } from '../Text/Text'

type Props = {
  className?: string
  id: string | undefined
  isLabelRedundant: boolean | undefined
  isRequired: boolean | undefined
  label: React.ReactNode
  tooltip: string | null | undefined
}
const FormControlLabel = ({
  className,
  id,
  isLabelRedundant,
  isRequired,
  label,
  tooltip,
}: Props) => {
  const labelContent = useMemo(
    () => (
      <HStack gap={1} align="baseline">
        {typeof label === 'string' ? (
          <T.Label as="span">
            {label}
            {isRequired && (
              <T.Body as="span" className="text-red-700">
                &nbsp;*
              </T.Body>
            )}
          </T.Label>
        ) : (
          <Flex>
            {label}
            {isRequired && (
              <T.Body as="span" className="text-red-700">
                &nbsp;*
              </T.Body>
            )}
          </Flex>
        )}
        {!getIsRichTextEmpty(tooltip) && (
          <QuickTip
            content={<RenderedRichTextInput>{tooltip}</RenderedRichTextInput>}
            // Since these tooltips are rich text that can contain links, we need them to be click-controlled for accessibility
            trigger="click"
          />
        )}
      </HStack>
    ),

    [isRequired, label, tooltip]
  )

  if (isLabelRedundant) {
    // Avoids "Multiple form labels" accessibility error
    return labelContent
  }

  return (
    <label htmlFor={id} className={className}>
      {labelContent}
    </label>
  )
}

export default React.memo(FormControlLabel)
